import { useResponsiveValue } from '@superdispatch/ui';
import { SidebarContainer } from '@superdispatch/ui-lab';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { PermissionView } from 'shared/modules/permission/core/PermissionView';
import { ProfileSidebar } from './ProfileSidebar';
import { superPayRoutes } from './ProfileSuperPayPage';
import { InstantTransferTermsContentPage } from './superpay/instant-transfer-terms/InstantTransferTermsContent';
import { verifiedCarrierApplicationRoutes } from './verified-carrier-application/ProfileVerifiedCarrierApplicationOutlet';
import { lazyImport } from 'shared/routing/LazyRoute';

const ProfileACHPaymentInfoPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileACHPaymentInfoPage',
);
const ProfileBillingInfoPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileBillingInfoPage',
);
const ProfileBusinessLicensePage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileBusinessLicensePage',
);
const ProfileCargoInsurancePage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileCargoInsurancePage',
);
const ProfileCarrierInfoPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileCarrierInfoPage',
);
const ProfileOverviewPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileOverviewPage',
);
const ProfilePhoneVerificationPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfilePhoneVerificationPage',
);
const ProfileStateMotorCarrierPermitPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileStateMotorCarrierPermitPage',
);
const ProfileTermsAndConditionsPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileTermsAndConditionsPage',
);
const ProfileTransporterPlateRegistrationPage = lazyImport(
  () => import('./ProfilePages'),
  'ProfileTransporterPlateRegistrationPage',
);
const ProfileW9Page = lazyImport(
  () => import('./ProfilePages'),
  'ProfileW9Page',
);

function ProfilePage() {
  const isMobile = useResponsiveValue(true, false);

  if (isMobile) {
    return <SidebarContainer sidebar={<ProfileSidebar />} />;
  }

  return <Navigate to="/profile/overview" replace={true} />;
}

function ProfileContainerOutlet() {
  const isMobile = useResponsiveValue(true, false);

  if (isMobile) {
    return <Outlet />;
  }

  return (
    <SidebarContainer sidebar={<ProfileSidebar />}>
      <Outlet />
    </SidebarContainer>
  );
}

export const profileRoutes: RouteObject[] = [
  {
    path: 'profile',
    children: [
      ...verifiedCarrierApplicationRoutes,
      {
        path: 'phone-verification',
        element: <ProfilePhoneVerificationPage />,
      },
      {
        path: 'superpay/onboarding/instant-transfer-terms',
        element: (
          <PermissionView name="superpay" permission="can_view">
            <InstantTransferTermsContentPage />
          </PermissionView>
        ),
      },
      {
        path: '*',
        element: <ProfileContainerOutlet />,
        children: [
          ...superPayRoutes,
          {
            path: 'overview',
            element: <ProfileOverviewPage />,
          },
          {
            path: 'carrier_info',
            element: <ProfileCarrierInfoPage />,
          },
          {
            path: 'cargo_insurance',
            element: <ProfileCargoInsurancePage />,
          },
          {
            path: 'w9',
            element: <ProfileW9Page />,
          },
          {
            path: 'transporter_plate_registration',
            element: <ProfileTransporterPlateRegistrationPage />,
          },
          {
            path: 'state_motor_carrier_permit',
            element: <ProfileStateMotorCarrierPermitPage />,
          },
          {
            path: 'business_license',
            element: <ProfileBusinessLicensePage />,
          },
          {
            path: 'billing_info',
            element: <ProfileBillingInfoPage />,
          },
          {
            path: 'ach_payment',
            element: <ProfileACHPaymentInfoPage />,
            children: [{ path: 'change-bank-details', element: null }],
          },
          {
            path: 'terms_and_conditions',
            element: <ProfileTermsAndConditionsPage />,
          },
        ],
      },
      { index: true, element: <ProfilePage /> },
    ],
  },
];
